<template>
  <div ref="legalFooter" class="legal-footer">
    <a class="legal-footer__link" :href="$t('footer.privacyPolicy.url')" target="_blank">
      {{ $t('footer.privacyPolicy.label') }}
    </a>

    <a class="legal-footer__link" :href="$t('footer.termsOfUse.url')" target="_blank">
      {{ $t('footer.termsOfUse.label') }}
    </a>

    <a class="legal-footer__link" :href="$t('footer.legal.url')" target="_blank">
      {{ $t('footer.legal.label') }}
    </a>
  </div>
</template>

<script>
export default {
  name: 'LegalFooter',

  mounted() {
    // This moves the cookie preference setting into the Footer
    // the original element gets hidden globally in the sapOverwrites.scss file
    // even if this component is not mounted
    const cookieLink = document.querySelector('#teconsent a');
    const legalDiv = this.$refs.legalFooter;

    if (cookieLink && legalDiv) {
      cookieLink.classList.add('legal-footer__link');
      cookieLink.innerHTML = this.$t('footer.cookiePreferences');
      legalDiv.appendChild(cookieLink);
    }
  },
};
</script>

<style lang="scss" scoped>
.legal-footer {
  font-size: rem(10px);
  display: flex;
  justify-content: center;

  @include helper__greater($bp-768) {
    justify-content: flex-end;
    padding-right: 20px;
  }
}

// since the manually added link doesn't have scoped styles
::v-deep .legal-footer__link {
  padding: 20px 10px;
  opacity: 0.6;
  transition: opacity 0.3s ease;
  text-decoration: underline;
  white-space: nowrap;

  @include helper__greater($bp-375) {
    padding-left: 20px;
    padding-right: 20px;
  }

  &:hover {
    opacity: 1;
  }
}
</style>
